import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

export default class HeroImageAnimation {
	constructor() {
		this.imageContainer = document.querySelector('[data-hero-image]');

		if (!this.imageContainer) {
			return;
		}

		this.isMobile = window.matchMedia('(max-width: 767px)').matches;

		this.animatedImage = this.imageContainer.querySelector('[data-hero-image-img]');

		if (!this.animatedImage) {
			return;
		}

		this.initAnimation();
	}

	initAnimation() {
		gsap.to(this.animatedImage, {
			'--img-width': '100vw',
			'--img-radius': '0px',
			duration: 0.8,
			ease: 'sine.inOut',
			scrollTrigger: {
				trigger: this.imageContainer,
				start: this.isMobile ? 'top bottom-=100px' : 'top 50%',
				toggleActions: 'play none none reverse',
			},
		});
	}
}
